// extracted by mini-css-extract-plugin
export default {"container":"loader_container__bejJm","logo":"loader_logo__9BATc","bounce":"loader_bounce__dFtJE","shadow":"loader_shadow__hlxf1","grow":"loader_grow__7+YTY"};